module.exports = __webpack_public_path__ + "img/partner33.f61b9dba.png";